const DB_NAME = 'bangke-app-db';
const DB_VERSION = 1;
const STORE_NAME = 'app-data';

export function openDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve(request.result);

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'id' });
      }
    };
  });
}

export async function saveData(data) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction([STORE_NAME], 'readwrite');
    const store = transaction.objectStore(STORE_NAME);
    
    const dataWithId = { id: 'main', ...data, updatedAt: new Date().toISOString() };
    const request = store.put(dataWithId);

    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve(request.result);
  });
}

export async function loadData() {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction([STORE_NAME], 'readonly');
    const store = transaction.objectStore(STORE_NAME);
    const request = store.get('main');

    request.onerror = () => reject(request.error);
    request.onsuccess = () => {
      const result = request.result;
      resolve(result || null);
    };
  });
}

export async function clearData() {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction([STORE_NAME], 'readwrite');
    const store = transaction.objectStore(STORE_NAME);
    const request = store.clear();

    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve();
  });
}

export function exportToJSON(data) {
  const exportData = {
    version: '1.0',
    exportDate: new Date().toISOString(),
    appName: '蚌壳',
    data: data
  };
  
  const blob = new Blob([JSON.stringify(exportData, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `蚌壳备份_${new Date().toISOString().slice(0, 10)}.json`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export async function importFromJSON(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = async (event) => {
      try {
        const imported = JSON.parse(event.target.result);
        
        if (!imported.data || typeof imported.data !== 'object') {
          reject(new Error('无效的备份文件格式'));
          return;
        }
        
        const data = imported.data;
        
        const requiredFields = ['wallet', 'savings', 'tasks', 'creditScore'];
        for (const field of requiredFields) {
          if (!(field in data)) {
            reject(new Error(`备份文件缺少必要字段：${field}`));
            return;
          }
        }
        
        resolve({
          wallet: data.wallet,
          savings: data.savings,
          tasks: data.tasks,
          creditScore: data.creditScore,
          logs: data.logs || [],
          lastSettledDate: data.lastSettledDate
        });
      } catch (error) {
        reject(new Error('JSON 解析失败：' + error.message));
      }
    };
    
    reader.onerror = () => reject(new Error('文件读取失败'));
    reader.readAsText(file);
  });
}
